import React, {useEffect, useState} from 'react';
import {Button} from '../../components/Button';
import {DirectoryBar} from '../../components/DirectoryBar';
import {H6} from '../../components/H6';
import {InfoSection} from '../../components/MyPage/InfoSection';
import {ShippingInfoSection} from '../../components/MyPage/ShippingInfoSection';
import {PopUp} from '../../components/PopUp';
import {Section} from '../../components/Section';
import {Table} from '../../components/Table';
import {TextField} from '../../components/TextField';
import {useHistory, useParams} from "react-router-dom";
import useOrderDetail from "../../hooks/useOrderDetail";
import {
    OrderChangeAddressDto,
    OrderPaidProduct,
    OrderRequestCreateDto,
    OrderRequestPrepaidDto,
    OrderRequestProductDto,
    OrderStart,
    PayMethod, TOrderDetail
} from "../../types/types";
import PaymentInfoPC from "../../components/PaymentInfoPC";
import PaymentInfoMobile from "../../components/PaymentInfoMobile";
import {getOrderHistoryDetail, orderRequestCreate, orderRequestPrePaid} from "../../apis/orders";
import OrderNumberSection from "../../components/OrderNumberSection";
import {AccountSection} from "../../components/MyPage/AccountSection";
import {Select} from "../../components/Select";
import {payMethodCode} from "../../utils/payMethod";
import {InfoItem} from "../../components/MyPage/InfoItem";
import RefundInfo from '../../components/RefundInfo';
import { useUserState } from '../../context/UserContext';
import {nToast} from "../../plugins/reactToast";
import { MyPageEventProperties } from '../../types/amplitudeEventProperties';
import { Bridge } from '../../plugins/bridge';
import { AIRBRIDGE_EVENT } from '../../constants/airbridge';
import { isMobile } from 'react-device-detect';
import {iamportPaymentRequest} from "../../apis/iamport";
import {PayStartResultV2Dto} from "../../types/iamport";
import {payCode} from "../../utils/payCode";
import moment from "moment";
import { getPG } from '../../utils/getPG';

export const MyPageOrdersRefund = () => {
    const {orderNumber} = useParams<{ orderNumber: string }>();
    const [popUp, setPopUp] = useState(false);
    const {order, setOrder} = useOrderDetail(orderNumber);
    const history = useHistory();
    // @ts-ignore
    const {nOrder, products}: { nOrder: TOrderDetail, products: OrderPaidProduct[] } = history.location.state;
    const [prePaid, setPrePaid] = useState<OrderRequestPrepaidDto>()
    const [payMethod, setPayMethod] = useState<PayMethod>('CARD')
    const [orderProducts, setOrderProducts] = useState<OrderRequestProductDto[]>([]);
    const [changedAddress, setChangedAddress] = useState<OrderChangeAddressDto>()
    const [refundInfo, setRefundInfo] = useState<{ refundAccountBank?: string, refundAccountNumber?: string }>({})
    const {isLoggedIn} = useUserState();

    useEffect(() => {
        let list: number[] = []
        products.forEach((item) => list.push(item.orderProductId))
        const customerName = localStorage.getItem('customerName');
        const customerPhone = localStorage.getItem('customerPhone');
        orderRequestPrePaid(orderNumber, {
            customerName: customerName!,
            customerPhone: customerPhone!,
            orderProductIds: list,
            orderRequestType: 'RETURN'
        }).then(r => setPrePaid(r.data.payload))
    }, [isLoggedIn])

    useEffect(() => {
        if (nOrder) {
            setOrder(nOrder)
        } else {
            getOrderHistoryDetail(orderNumber).then(r => setOrder(r.data.payload))
        }
    }, [orderNumber])

    useEffect(() => {
        let list: OrderRequestProductDto[] = [];
        products.forEach(item => list.push({
            orderProductId: item.orderProductId,
            reason: ''
        }));
        setOrderProducts(list);
    }, [products])

    if (!order || !prePaid) return null

    const prePay = (mobileReturnUrl?: string) => {
        const data: OrderRequestCreateDto = {
            orderProducts: orderProducts,
            newUserAddress: changedAddress?.newUserAddress || undefined,
            orderRequestType: 'RETURN',
            payMethod: payMethod,
            receiverAddress: changedAddress?.receiverAddress || order.receiverAddress,
            receiverDetailAddress: changedAddress?.receiverDetailAddress || order.receiverDetailAddress,
            receiverName: changedAddress?.receiverName || order.receiverName,
            receiverPhone: changedAddress?.receiverPhone || order.receiverPhone,
            receiverPostcode: changedAddress?.receiverPostcode || order.receiverPostcode,
            refundAccountBank: refundInfo.refundAccountBank,
            refundAccountName: order.customerName,
            refundAccountNumber: refundInfo.refundAccountNumber,
            userAddressId: undefined,
        }
        if (!isLoggedIn) {
            data.requesterName = order.customerName
            data.requesterPhone = order.customerPhone
            localStorage.setItem('customerName', order.customerName!)
            localStorage.setItem('customerPhone', order.customerPhone!)
        }
        if (mobileReturnUrl) {
            data.mobileReturnUrl = mobileReturnUrl
            iamportPaymentRequest(orderNumber, data).then(r => {
                Bridge.sendAirbridge(AIRBRIDGE_EVENT.orderCancel, {
                    action: "환불",
                    value: order?.totalPrice,
                    semanticAttributes: {
                        transactionID: order?.orderId,
                        inAppPurchased: isMobile,
                        totalValue : order?.totalPrice,
                        currency: "KRW",
                        totalQuantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
                        products: order?.products
                    }
                })
                pay(r.data.payload);
                // history.push('/cart/request/processing', {
                //     paymentInfo: r.data.payload,
                //     orderInfo: data
                // })
            }).catch(e => console.log('mobile payment request error', e))
        } else {
            iamportPaymentRequest(orderNumber, data)
            .then(r => {
                Bridge.sendAirbridge(AIRBRIDGE_EVENT.orderCancel, {
                    action: "환불",
                    value: order?.totalPrice,
                    semanticAttributes: {
                        transactionID: order?.orderId,
                        inAppPurchased: isMobile,
                        totalValue : order?.totalPrice,
                        currency: "KRW",
                        totalQuantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
                        products: order?.products
                    }
                })
                pay(r.data.payload)
            })
            .catch(e => e.response.status === 403 && nToast(e.response.data.message))
        }
    }

    const pay = (data: PayStartResultV2Dto) => {
        const redirectUrl = `${window.location.protocol + "//" + window.location.host}/cart/request/success/mobile`;
        // @ts-ignore
        const { IMP } = window;
        IMP.request_pay({
            pg: getPG(payMethod),
            pay_method: payCode(payMethod),
            merchant_uid: data.orderNumber,
            name: '칼하트윕 상품 반품',
            amount: data.totalPrice,
            buyer_name: order.customerName,
            buyer_tel: order.customerPhone,
            buyer_addr: order.receiverAddress,
            m_redirect_url: redirectUrl,
            app_scheme: 'carhartt',
          }, (rsp: any) => {
            console.log(rsp);
            if (rsp.success === true) {
              // 결제 성공 시 로직,
              console.log('success');
              if (isMobile) {
                // history.push('/cart/payment/success/mobile');
              } else {
                history.push(`/cart/request/success?imp_uid=${rsp.imp_uid}&merchant_uid=${rsp.merchant_uid}&imp_success=${rsp.imp_success}`);
              }
            } else {
              // 결제 실패 시 로직,
              alert(`결제에 실패했습니다. ${rsp.error_msg}`);
            }
          });
    }

    return (
        <>
            <DirectoryBar text="반품 신청" backArrow className="md:hidden"/>

            <PopUp
                title="정말 반품신청을 하시겠습니까?"
                buttonText="신청하기"
                open={popUp}
                onClose={() => setPopUp(false)}
                onClick={() => prePay()}
                onClickMobile={() => prePay(`${window.location.protocol + "//" + window.location.host}/cart/request/success/mobile`)}
            />

            <div className={nOrder ? "md:mx-auto md:my-30 max-w-screen-xl space-y-14" : "space-y-14"}>
                <Section className="space-y-4 text-13">
                    <H6 className="border-b pb-2">반품 신청</H6>

                    <OrderNumberSection orderNumber={order.orderNumber} orderedAt={order.orderedAt!}/>

                    {/* Desktop */}
                    <Table className="hidden md:table mt-5">
                        <Table.Head>
                            <Table.Row>
                                <Table.Th>상품</Table.Th>
                                <Table.Th>반품사유(선택)</Table.Th>
                            </Table.Row>
                        </Table.Head>
                        <Table.Body>
                            {products.map((product, index) => (
                                <Table.Row key={index}>
                                    <Table.Td>
                                        <div className="flex space-x-4 font-normal items-center">
                                            <div className="w-20 h-28 relative rounded-md overflow-hidden">
                                                <img
                                                    src={product.thumbnailUrl}
                                                    alt=""
                                                    className="w-full h-full object-cover absolute"
                                                />
                                            </div>
                                            <div className="space-y-2 text-10 font-semibold">
                                                <p className="whitespace-normal">
                                                    {product.productName}
                                                    <br/>
                                                    <span className="text-brand-3">{product.color}</span>
                                                </p>
                                                <p className="text-brand-3">{product.unitPrice.toLocaleString()}원/수량 {product.count}개</p>
                                            </div>
                                        </div>
                                    </Table.Td>

                                    <Table.Td>
                                        <TextField className="border-gray-100"
                                                   placeholder={`사유를 입력해주세요.`}
                                                   onChange={(e) => {
                                                       let products = [...orderProducts];
                                                       products[index].reason = e.target.value;
                                                       setOrderProducts([...products]);
                                                   }}
                                        />
                                    </Table.Td>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>

                    {/* Mobile */}
                    <Section className="flex flex-col space-y-4 md:hidden">
                        {products.map((product, index) => (
                            <div className="flex justify-between items-center border-b pb-4" key={index}>
                                <div className="flex space-x-4 font-normal items-center">
                                    <div className="w-20 h-28 relative rounded-md overflow-hidden">
                                        <img
                                            src={product.thumbnailUrl}
                                            alt=""
                                            className="w-full h-full object-cover absolute"
                                        />
                                    </div>

                                    <div className="space-y-2 text-10 font-semibold">
                                        <p className="whitespace-normal">{product.productName}</p>
                                        <span className="text-brand-3">{product.color}</span>

                                        <p className="text-brand-3">{product.unitPrice.toLocaleString()}원/수량 {product.count}개</p>
                                    </div>
                                </div>

                                <TextField className="border-gray-100"
                                           placeholder={`사유를 입력해주세요.`}
                                           onChange={(e) => {
                                               let refundProducts = [...orderProducts];
                                               console.log(refundProducts);
                                               refundProducts[index].reason = e.target.value;
                                               setOrderProducts([...refundProducts]);
                                           }}
                                />

                                {/*<Select*/}
                                {/*    className="border pl-2 border-gray-200"*/}
                                {/*    onChange={(e) => console.log(e.target.value)}*/}
                                {/*>*/}
                                {/*    <option value="1">교환사유</option>*/}
                                {/*    <option value="2">사이즈 변경</option>*/}
                                {/*</Select>*/}
                            </div>
                        ))}
                    </Section>

                    <p className="flex flex-row-reverse text-gray-500 text-13">
                        *교환 진행시, 교환 신청한 사이즈가 품절될 시 환불처리가 진행됩니다.
                    </p>
                </Section>

                <InfoSection name={order.customerName!} phone={order.customerPhone!}/>

                {changedAddress ? (
                    <ShippingInfoSection order={order}
                                         changed={changedAddress}
                                         isExchange={true}
                                         hideActions={!order.orderRequestExtra || order.orderRequestExtra?.status === 'READY'}
                                         onChangeAddress={(data) => setChangedAddress(data)}
                    />
                ) : (
                    <ShippingInfoSection order={order}
                                         isExchange={true}
                                         hideActions={!order.orderRequestExtra || order.orderRequestExtra?.status === 'READY'}
                                         onChangeAddress={(data) => setChangedAddress(data)}
                    />
                )}

                <Section className="space-y-4 text-13">
                    <H6 className="border-b pb-2">
                        반품 비용 결제
                    </H6>

                    <div className="grid grid-cols-2">
                        <InfoItem title="총 반품 비용"
                                  content={`${prePaid.totalPrepayingAmount.toLocaleString()}원`}/>
                        <InfoItem title="반품 비용 결제" content="선결제"/>
                    </div>
                </Section>

                <Section>
                    <H6 className="pb-2">결제 수단</H6>
                    <Select
                        className="md:w-1/6 border border-gray-100 pl-4"
                        onChange={(e) => setPayMethod(e.target.value as PayMethod)}
                    >
                        <option value="CARD">신용카드</option>
                        <option value="TRANSFER">실시간 계좌이체</option>
                    </Select>
                </Section>
                {(order.payMethod !== 'CARD' && order.payMethod !== 'KAKAO' && order.payMethod !== 'NAVER') && (
                    <AccountSection order={order}
                                    onChangeAccount={(accountInfo) => setRefundInfo(accountInfo)}
                    />
                )}

                {/* Desktop 환불 정보 */}
                <Section className="hidden md:block text-13">
                    <H6 className="border-b pb-2">환불 정보</H6>

                    <RefundInfo order={order} prepaid={prePaid} isMobile={false}/>
                </Section>

                {/* Mobile 환불 정보 */}
                <Section className="md:hidden text-13">
                    <H6 className="border-b pb-2 mb-4">환불 정보</H6>

                    <RefundInfo order={order} prepaid={prePaid} isMobile={true}/>
                </Section>

                <div className="flex flex-row-reverse font-normal">
                    <Button
                        // disabled
                        onClick={() => setPopUp(true)}
                        text="결제 및 반품신청"
                        className="filled-brand-1 px-10"
                    />
                </div>
            </div>
        </>
    );
};
